export default {
  Loaded: 'loaded',
  Resize: 'resize',
  ScrollTop: 'scrollTop',
  Finished: 'finished',
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/HostedPaymentIframePostEventTypes.js